import {
  Collections,
  type DonationsConfirmationsResponse,
  type DonationsResponse
} from '$types/pocketbase';
import { pbClient } from '$lib/client/pocketbase';

export const getMyDonations = () =>
  pbClient.collection(Collections.Donations).getFullList<DonationsResponse>();

export const getMyConfirmations = () =>
  pbClient
    .collection(Collections.DonationsConfirmations)
    .getFullList<DonationsConfirmationsResponse>();
